import { types } from "../types/types";

export const setTipo = (data) => {
  return {
    type: types.setTipo,
    payload: data,
  };
};
